import React from 'react';
import type {
  FormBlurEventFn,
  FormChangeEventFn,
  SetFormValueFn,
} from '@noths/polaris-client-react-hooks';
import { TextField } from '@noths/polaris-client-ribbons-design-system';

import { RadioButtonGroup } from 'src/components/molecules/RadioButtonGroup/RadioButtonGroup';
import { YES_NO_OPTIONS } from 'src/components/organisms/Signup/constants/aboutYourBusinessOptions';
import {
  PIPELINE_PLANS_DETAILS_COPY,
  PIPELINE_PLANS_PROVIDED_COPY,
} from 'src/components/organisms/Signup/constants/copy';
import { PIPELINE_PLANS_PROVIDED } from 'src/components/organisms/Signup/constants/testIds';
import type { FormValidationErrors } from 'src/components/organisms/Signup/types';
import * as styles from 'src/styles/styles';
import type { RegistrationForm } from 'src/types/registration';

interface Props {
  clearError: (errorName: string) => void;
  errors: FormValidationErrors;
  formValues: RegistrationForm;
  onBlur: FormBlurEventFn;
  onFormChange: FormChangeEventFn;
  setFormValue: SetFormValueFn<RegistrationForm>;
}

export const PipelinePlans = ({
  clearError,
  errors,
  formValues,
  onBlur,
  onFormChange,
  setFormValue,
}: Props) => {
  return (
    <>
      <RadioButtonGroup
        accessibleLabel={PIPELINE_PLANS_PROVIDED_COPY}
        additionalCss={styles.grouped}
        data-testid={PIPELINE_PLANS_PROVIDED}
        error={errors['pipelinePlans.provided'] as string | undefined}
        name="pipelinePlans.provided"
        onBlur={onBlur}
        onChange={(provided) => {
          if (provided) {
            setFormValue('pipelinePlans.provided' as keyof RegistrationForm, provided);
          } else {
            setFormValue('pipelinePlans' as keyof RegistrationForm, {
              provided,
              details: '',
            });
            clearError('pipelinePlans.provided');
            clearError('pipelinePlans.details');
          }
        }}
        radioButtonData={YES_NO_OPTIONS}
        required
        value={formValues.pipelinePlans.provided}
      />
      {formValues.pipelinePlans.provided && (
        <div css={styles.easeIn}>
          <TextField
            css={styles.textField}
            error={errors['pipelinePlans.details'] as string | undefined}
            id="business-pipeline-plans-details"
            label={PIPELINE_PLANS_DETAILS_COPY}
            name="pipelinePlans.details"
            onBlur={onBlur}
            onChange={onFormChange}
            required
            rows={5}
            value={formValues.pipelinePlans.details}
          />
        </div>
      )}
    </>
  );
};
